import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';

import { HeatTraceClearOverview, HeatTraceLoadOverview } from '@completion/actions';
import { State } from '@completion/reducers';
import { getCurrentOverviewTag, getOverview, getOverviewLoading } from '@completion/selectors';
import { HeatTraceFilterStateService } from '../heat-trace-filter-state.service';

@Component({
  selector: 'app-test-header',
  templateUrl: './test-header.component.html',
  styleUrls: ['./test-header.component.scss'],
  standalone: false,
})
export class TestHeaderComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  tagNumber$ = this.route.paramMap.pipe(
    map((paramMap) => paramMap.get('tagNumber')),
    distinctUntilChanged(),
  );

  overview$ = this.store.select(getOverview);
  overviewLoading$ = this.store.select(getOverviewLoading);
  currentOverviewTag$ = this.store.select(getCurrentOverviewTag);

  viewModel = {
    tagNumber: 'Unknown',
    elementType: null as string | null,
    elementTagNumber: null as string | null,
  };

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly store: Store<State>,
    private readonly heatTraceFilterState: HeatTraceFilterStateService,
  ) {}

  goBackToOverview(): void {
    const persistedFilter = this.heatTraceFilterState.get();
    const queryParams: Params = {};

    if (persistedFilter.date) {
      queryParams.date = persistedFilter.date;
    }

    if (persistedFilter.week !== null) {
      queryParams.week = persistedFilter.week;
    }

    this.router.navigate(['/heat-trace'], {
      queryParams: Object.keys(queryParams).length > 0 ? queryParams : undefined,
    });
  }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((paramMap) => {
      this.viewModel = {
        tagNumber: paramMap.get('tagNumber') ?? 'Unknown',
        elementType: paramMap.get('elementType'),
        elementTagNumber: paramMap.get('elementTagNumber'),
      };
    });

    this.tagNumber$
      .pipe(
        filter((tagNumber): tagNumber is string => tagNumber !== null),
        takeUntil(this.destroy$),
      )
      .subscribe((tagNumber) => {
        this.store.dispatch(new HeatTraceLoadOverview(tagNumber));
      });
  }

  ngOnDestroy(): void {
    this.store.dispatch(new HeatTraceClearOverview());
    this.destroy$.next();
    this.destroy$.complete();
  }
}
